import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import dayjs from 'dayjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-project-calendar',
    templateUrl: './project-calendar.component.html',
    styleUrls: ['./project-calendar.component.less']
})
export class ProjectCalendarComponent implements OnInit, OnChanges{
    @ViewChild('calendar') calendar!: FullCalendarComponent;
    @Input() events: EventInput[] = [];
    @Output() changeRange = new EventEmitter();
    calendarOptions: CalendarOptions = {
        selectable: true,
        initialView: 'dayGridMonth',
        headerToolbar: {
            left: 'prev,next',
            center: 'title',
            right: ''
        },
        selectAllow: () => {
            return false;
        },
        datesSet: (val) => {
            const {
                startStr,
                endStr
            } = val;
            const range = [dayjs(startStr).format('YYYY-MM-DD'), dayjs(endStr).format('YYYY-MM-DD')];
            this.changeRange.emit(range);
        },
        events: []
    };
    isVisible = false;

    setCalendarStart(startDate: string): void {
        console.log(startDate);
        const calendarApi = this.calendar?.getApi();
        if (calendarApi) {
            calendarApi.gotoDate(dayjs(startDate).format('YYYY-MM-DD'));
        }
    }

    constructor(private msg: NzMessageService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.events) {
            return;
        }
        this.calendarOptions.events = this.events;
    }

    close(): void {
        this.isVisible = false;
    }
}
